'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import Layout from 'Layouts/Back';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Switch from 'Components/Forms/Elements/Switch';
import LoungeStatsBlock from 'Components/Blocks/LoungeStatsBlock';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import { num, formatNum } from 'Shared/utilities';
import { action } from 'Shared/Routes';
import Loader from 'Pure/Loader';
const {
  moment
} = window;
const cards = [{
  title: 'CA Lounge',
  field: 'ca',
  suffix: '€'
}, {
  title: 'CA Lounge hors service',
  field: 'ca_without_services',
  suffix: '€'
}, {
  title: 'Panier moyen Lounge',
  field: 'average',
  suffix: '€'
}, {
  title: 'Panier moyen Lounge hors service',
  field: 'average_without_services',
  suffix: '€'
}, {
  title: 'Nombre de transactions Lounge',
  field: 'transaction_count'
}, {
  title: 'Nombre de siège Lounge vendu',
  field: 'count_people'
}, {
  title: 'Nombre moyen de siège Lounge vendu',
  field: 'people_average'
}, {
  title: 'Durée totale d\'heure réservé Lounge',
  field: 'lounge_duration',
  suffix: 'h'
}, {
  title: 'Durée moyenne des réservations Lounge',
  field: 'lounge_duration_average',
  suffix: 'h',
  format: '0,0[.]0'
}, {
  title: 'Fenêtre de réservation Lounge',
  field: 'booking_window',
  suffix: 'j'
}];
function getDefaultState() {
  const state = {
    start_date: '',
    end_date: '',
    global_stats: true,
    super_admin: window.location.pathname.startsWith('/super-admin-indicateurs'),
    status_messages: {}
  };
  if (state.super_admin) {
    state.start_date = moment().startOf('month').subtract(6, 'months').format('YYYY-MM-DD');
  }
  return state;
}
export default class LoungeIndicatorPage extends Component {
  state = {
    ...getDefaultState.bind(this)(),
    series: [{
      name: 'Nombre de transactions',
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }],
    options: {
      fill: {
        colors: ["#003768"]
      },
      chart: {
        height: 350,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: 'top' // top, center, bottom
          }
        }
      },

      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ["#003768"]
        }
      },
      xaxis: {
        categories: ["7h", "8h", "9h", "10h", "11h", "12h", "13h", "14h", "15h", "16h", "17h", "18h", "19h", "20h", "21h"],
        position: 'top',
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#003768',
              colorTo: '#003768',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5
            }
          }
        },
        tooltip: {
          enabled: true
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val;
          }
        }
      },
      title: {
        text: 'Répartition des transactions par créneau horaire',
        floating: true,
        offsetY: 330,
        align: 'center',
        style: {
          color: '#003768'
        }
      }
    }
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchStats({});
  }
  handleFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    if (e !== null)
      // did mount
      {
        component.fetchStats({
          filters: {
            [name]: value
          }
        });
      }
  };
  fetchStat = async ({
    name,
    filters = {},
    ...other_params
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const params = {};
    ['start_date', 'end_date', 'super_admin', 'global_stats'].forEach(function (field) {
      params[field] = typeof filters[field] === 'undefined' ? state[field] : filters[field];
    });
    const response = await ajaxRequest(action(name), {
      data: {
        ...params,
        ...other_params
      }
    });
    return response;
  };
  fetchStats = async ({
    filters = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    const actions = [{
      name: 'getCA'
    }, {
      name: 'getCAWithoutServices'
    }, {
      name: 'getCartAverage'
    }, {
      name: 'getCartAverageWithoutServices'
    }, {
      name: 'getTransactionCount'
    }, {
      name: 'getTotalPeopleCount'
    }, {
      name: 'getPeopleCountAverage'
    }, {
      name: 'getLoungeDuration'
    }, {
      name: 'getLoungeDurationAverage'
    }, {
      name: 'getLoungeTransactionByHours'
    }, {
      name: 'getBookingWindow'
    }].map(data => ({
      ...data,
      filters,
      type: 'a_calm_coworking_space'
    }));
    try {
      const requests = actions.map(params => component.fetchStat(params));
      var results = await Promise.all(requests);
    } catch (e) {
      return component.setState(e);
    }
    const update = {
      loading: false
    };
    results.forEach(function (response, i) {
      if (actions[i].name === 'getLoungeTransactionByHours') {
        let series_data = Object.keys(response.lounge_transaction_by_hours || {}).map(function (hours) {
          return response.lounge_transaction_by_hours[hours];
        });
        Object.assign(update, {
          series: [{
            name: 'Nombre de transactions',
            data: series_data
          }]
        });
      } else {
        Object.assign(update, response);
      }
    });
    component.setState(update);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const stat_loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const stats = cards.map(function ({
      title,
      field,
      suffix,
      format
    }) {
      return /*#__PURE__*/React.createElement("div", {
        className: "c-stats__item",
        key: field
      }, /*#__PURE__*/React.createElement("h3", {
        className: "c-stats__item-title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "c-stats__item-result"
      }, formatNum(state[field], format || '0,0[.]00'), suffix), stat_loader);
    });
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Indicateurs Lounge"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['start_date'] || "",
      className: "cutom-date-picker",
      name: "start_date",
      label: "Date de d\xE9but",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['end_date'] || "",
      className: "cutom-date-picker",
      name: "end_date",
      label: "Date de fin",
      "allow-no-value": true,
      status: state.status_messages
    })), state.super_admin ? /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleFilterChange,
      value: state.global_stats,
      name: "global_stats",
      label: "Afficher les stats globales",
      status: state.status_messages
    })) : undefined), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-stats"
    }, stats)), stat_loader ? /*#__PURE__*/React.createElement("div", {
      className: "c-paper",
      style: {
        height: 380,
        position: 'relative',
        width: '100%',
        overflow: 'hidden'
      }
    }, stat_loader) : /*#__PURE__*/React.createElement(LoungeStatsBlock, {
      options: state.options,
      series: state.series
    })));
    return output;
  }
}
